import { render, staticRenderFns } from "./Wills.vue?vue&type=template&id=28965fc4"
import script from "./Wills.vue?vue&type=script&lang=js"
export * from "./Wills.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports